import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Paper,
    Typography,
} from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";

const RearrangeDialog = ({ open, onClose, modules = [], setModules }) => {
    const [localModules, setLocalModules] = useState([]);

    useEffect(() => {
        if (open) {
            setLocalModules(modules);
        }
    }, [open, modules]);

    const handleDragEnd = (result) => {
        if (!result.destination) return;

        const updated = Array.from(localModules);
        const [moved] = updated.splice(result.source.index, 1);
        updated.splice(result.destination.index, 0, moved);
        setLocalModules(updated);
    };

    const handleSave = () => {
        setModules(localModules);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                Rearrange Modules
                <Typography variant="body2" color="textSecondary">
                    Drag and drop modules to rearrange
                </Typography>
            </DialogTitle>

            <DialogContent>
                <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="moduleList">
                        {(provided) => (
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                style={{ minWidth: "300px" }}
                            >
                                {localModules.map((module, index) => (
                                    <Draggable
                                        key={`module-${index}`}
                                        draggableId={`module-${index}`}
                                        index={index}
                                    >
                                        {(provided) => (
                                            <Paper
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={{
                                                    padding: "10px",
                                                    marginBottom: "10px",
                                                    backgroundColor: "white",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "0.5rem",
                                                    cursor: "grab",
                                                    ...provided.draggableProps.style,
                                                }}
                                            >
                                                <Icon style={{ color: "#888" }}>drag_indicator</Icon>
                                                {`Module ${index + 1}: ${module.name}` || `Module ${index + 1}`}
                                            </Paper>

                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </DialogContent>

            <DialogActions>
                <MDButton onClick={onClose} variant="contained" color="secondary">
                    Cancel
                </MDButton>
                <MDButton onClick={handleSave} variant="contained" color="success">
                    Save
                </MDButton>
            </DialogActions>
        </Dialog>
    );
};

export default RearrangeDialog;
